'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/business/BusinessSection.tsx
import { Button, ImageWithPlaceholder, Paper, Typography } from "@wbk/ui";
import { Link, useRouter, useTranslation } from "@wbk/config";
import { ChevronIcon, OutlinedCheckIcon } from "@wbk/svg";
import { useDeviceDetect } from "@wbk/hooks";
import { jsx, jsxs } from "react/jsx-runtime";
var BusinessSection = ({ section, mini = false }) => {
  var _a, _b, _c;
  const { locale } = useRouter();
  const { t } = useTranslation("contentful_business");
  const { isMobile } = useDeviceDetect();
  const subtitle = (section == null ? void 0 : section.subtitle) || "";
  const image = "/@wbk/contentful/business/business-section-img.png";
  const cards = (_a = section == null ? void 0 : section.contentCollection) == null ? void 0 : _a.items;
  const buttonLabel = ((_b = cards == null ? void 0 : cards[0]) == null ? void 0 : _b.buttonLabel) || t("contentful_business:button_label");
  const buttonHref = ((_c = cards == null ? void 0 : cards[0]) == null ? void 0 : _c.href) || `/${locale}/business/help`;
  const list = [
    { title: t("contentful_business:business_section.list.list_1") },
    { title: t("contentful_business:business_section.list.list_2") },
    { title: t("contentful_business:business_section.list.list_3") }
  ];
  const mobileLink = /* @__PURE__ */ jsx(Link, { to: buttonHref, children: /* @__PURE__ */ jsxs(Typography, { variant: "link-S", className: "flex items-center gap-1", children: [
    /* @__PURE__ */ jsx("span", { children: t("contentful_business:business_section.sign_up") }),
    /* @__PURE__ */ jsx(ChevronIcon, { className: `h-2 w-2 ${locale.startsWith("ar") ? "rotate-180" : ""}` })
  ] }) });
  if (mini) {
    return /* @__PURE__ */ jsxs(
      Paper,
      {
        className: "group flex flex-col overflow-hidden data-[mobile=true]:flex-row data-[mobile=true]:gap-5 data-[mobile=true]:rounded-none data-[mobile=true]:p-0 md:flex-row",
        border: !isMobile,
        "data-mini": mini,
        "data-mobile": isMobile,
        children: [
          /* @__PURE__ */ jsxs("div", { className: "relative flex items-center group-data-[mobile=false]:hidden", children: [
            /* @__PURE__ */ jsx(
              ImageWithPlaceholder,
              {
                src: image,
                alt: section == null ? void 0 : section.title,
                className: "group-data-[mobile=true]:max-w-[7rem]"
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "absolute flex flex-col group-data-[mobile=true]:ltr:left-2 group-data-[mobile=true]:rtl:right-6", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "body-S", strong: true, children: t("contentful_business:business_section.reach") }),
              /* @__PURE__ */ jsx(Typography, { variant: "heading-S", children: t("contentful_business:business_section.million") }),
              /* @__PURE__ */ jsx(Typography, { variant: "heading-S", children: t("contentful_business:business_section.users") })
            ] })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "flex w-full grow flex-col items-center gap-5 group-data-[mobile=true]:flex-row", children: [
            /* @__PURE__ */ jsxs("div", { className: "grow", children: [
              isMobile ? /* @__PURE__ */ jsx(Typography, { variant: "label-L", children: t("contentful_business:business_section.add_business_here") }) : /* @__PURE__ */ jsx(Typography, { variant: "heading-S", children: t("contentful_business:business_section.title") }),
              /* @__PURE__ */ jsx("div", { className: "mt-4 space-y-2 group-data-[mobile=true]:hidden", children: list.map((card, index) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ jsx(OutlinedCheckIcon, { className: "text-success h-4 w-4 shrink-0" }),
                /* @__PURE__ */ jsx(Typography, { variant: "body-S", children: card.title })
              ] }, index)) }),
              isMobile && mobileLink
            ] }),
            /* @__PURE__ */ jsx(
              Button,
              {
                as: Link,
                to: buttonHref,
                theme: "action",
                shape: "outlined",
                className: "w-full max-w-md shrink-0 self-center group-data-[mobile=true]:hidden lg:max-w-max",
                children: buttonLabel
              }
            )
          ] })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx(
    DecoratedSection_default,
    {
      className: "group container",
      "data-mobile": isMobile,
      section: __spreadProps(__spreadValues({
        id: "business-section",
        webLinksCollection: { items: [] }
      }, section), {
        sectionBackground: void 0
      }),
      children: /* @__PURE__ */ jsxs(Paper, { className: "rounded-S mx-auto flex w-full flex-col overflow-hidden !p-0 group-data-[mobile=true]:flex-row md:flex-row", children: [
        /* @__PURE__ */ jsxs("div", { className: "relative flex max-w-32 items-center p-4", children: [
          /* @__PURE__ */ jsx(
            ImageWithPlaceholder,
            {
              src: image,
              alt: section == null ? void 0 : section.title,
              className: "group-data-[mobile=false]:max-w-32 group-data-[mobile=true]:max-w-[7rem]"
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "absolute flex flex-col justify-center ltr:p-3 rtl:right-11 group-data-[mobile=true]:rtl:right-10", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "body-S", strong: true, children: t("contentful_business:business_section.reach") }),
            /* @__PURE__ */ jsx(Typography, { variant: "heading-S", children: t("contentful_business:business_section.million") }),
            /* @__PURE__ */ jsx(Typography, { variant: "heading-S", children: t("contentful_business:business_section.users") })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex w-full grow flex-col gap-5 p-4 lg:flex-row lg:p-8", children: [
          /* @__PURE__ */ jsxs("div", { className: "grow p-2", children: [
            /* @__PURE__ */ jsxs("div", { className: "space-y-1 group-data-[mobile=false]:mb-5 group-data-[mobile=true]:mt-4", children: [
              isMobile ? /* @__PURE__ */ jsx(Typography, { variant: "label-L", children: t("contentful_business:business_section.add_business") }) : /* @__PURE__ */ jsx(Typography, { variant: "heading-M", children: t("contentful_business:business_section.title") }),
              /* @__PURE__ */ jsx(Typography, { variant: "heading-XXS", color: "text-secondary", children: subtitle })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "space-y-2 group-data-[mobile=true]:hidden", children: (cards == null ? void 0 : cards.length) > 0 ? cards.map((card, index) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
              card.icon && /* @__PURE__ */ jsx(
                ContentfulMedia_default,
                {
                  media: card.icon,
                  className: "h-5 w-5 shrink-0 object-contain"
                }
              ),
              /* @__PURE__ */ jsx(Typography, { variant: "body-S", children: card.title })
            ] }, index)) : list.slice(1).map((card, index) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ jsx(OutlinedCheckIcon, { className: "text-success h-5 w-5 shrink-0" }),
              /* @__PURE__ */ jsx(Typography, { variant: "body-S", children: card.title })
            ] }, index)) }),
            isMobile && mobileLink
          ] }),
          /* @__PURE__ */ jsx(
            Button,
            {
              as: Link,
              to: buttonHref,
              theme: section ? "primary" : "action",
              className: "w-full max-w-md shrink-0 self-center group-data-[mobile=true]:hidden lg:max-w-max",
              children: buttonLabel
            }
          )
        ] })
      ] })
    }
  );
};
var BusinessSection_default = BusinessSection;

export {
  BusinessSection_default
};
//# sourceMappingURL=chunk-JV46NB7S.mjs.map